import { render, staticRenderFns } from "./DictionaryManagement.vue?vue&type=template&id=0ab50858&scoped=true&"
import script from "./DictionaryManagement.vue?vue&type=script&lang=js&"
export * from "./DictionaryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab50858",
  null
  
)

export default component.exports